<template>
  <div class="home" :class="{ 'home--en': i18nState.lang === 'en' }" ref="scrollRef">
    <!-- tab s -->
    <div class="home-tab">
      <img src="../assets/images/LOGO.png" alt="logo" class="logo" />
      <div class="home-tabList">
        <span
          v-for="(item, index) in homeText.nav"
          :key="item"
          :class="{ activeBot: tabNum == index }"
          @click="tabChange(index)"
        >{{ item }}</span>
      </div>
      <button class="lang-switch" @click="toggleLanguage">{{ homeText.languageLabel }}</button>
    </div>
    <!-- tab e -->

    <!-- 动态组件 s -->
    <component :is="comName"></component>
    <!-- 动态组件 e -->

    <!-- 底部 s -->
    <bottom></bottom>
    <!-- 底部 e -->

  </div>
</template>

<script>
import Vue from "vue";
import siteText from "@/i18n/siteText";
const { preloadImage, scheduleIdlePreload } = require("@/utils/idlePreload");

const formWork = () =>
  import(/* webpackChunkName: "form-work" */ "@/components/formWork.vue");
const regard = () =>
  import(/* webpackChunkName: "regard" */ "@/components/regard.vue");
const bottom = () =>
  import(/* webpackChunkName: "bottom" */ "@/components/bottom.vue");
const Video = () =>
  import(/* webpackChunkName: "video-view" */ "@/components/video.vue");
const Product = () =>
  import(/* webpackChunkName: "product-view" */ "@/components/product.vue");
const News = () =>
  import(/* webpackChunkName: "news-view" */ "@/components/news.vue");
const Relation = () =>
  import(/* webpackChunkName: "relation-view" */ "@/components/relation.vue");

const childPagePreloadItems = [
  [regard, require("../assets/images/top.jpg")],
  [Video, require("../assets/images/videoView.jpg")],
  [Product, require("../assets/images/productView.jpg")],
  [News, require("../assets/images/news.jpg")],
  [Relation, require("../assets/images/relation.jpg")],
];

export default {
  name: "HomeView",
  components: {
    formWork,
    regard,
    bottom,
    Video,
    Product,
    News,
    Relation

  },
  data() {
    return {
      tabNum: 0,
      comName: "formWork",
      cancelIdlePreload: null,
      i18nState: Vue.observable({
        lang: "zh",
      }),
    };
  },
  computed: {
    homeText() {
      return siteText[this.i18nState.lang].home;
    },
  },
  provide() {
    return {
      tabChange: this.tabChange,
      i18nState: this.i18nState,
    }
  },
  mounted() {
    this.startBalancedPreload();
  },
  beforeDestroy() {
    if (this.cancelIdlePreload) {
      this.cancelIdlePreload();
      this.cancelIdlePreload = null;
    }
  },
  methods: {
    startBalancedPreload() {
      const tasks = childPagePreloadItems.reduce((result, [loadComponent, heroImage]) => {
        result.push(loadComponent, () => preloadImage(heroImage));
        return result;
      }, []);

      this.cancelIdlePreload = scheduleIdlePreload(tasks, {
        delay: 1600,
        stepDelay: 220,
      });
    },
    tabChange(num) {
      const arr = ["formWork", "regard", "Video", "Product", "News", "Relation"];
      this.tabNum = num;
      this.comName = arr[this.tabNum];
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    toggleLanguage() {
      this.i18nState.lang = this.i18nState.lang === "zh" ? "en" : "zh";
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  position: relative;
  width: 100%;
  min-width: 1200px;

  // tab
  .home-tab {
    position: absolute;
    top: 0;
    left: 20%;
    z-index: 9;
    display: flex;
    align-items: center;

    .logo {
      width: 74.31px;
      height: 60px;
    }

    .home-tabList {
      margin-left: 68px;
      display: flex;
      align-items: center;

      span {
        margin-right: 10px;
        min-width: 112px;
        padding: 0 10px;
        height: 68px;
        line-height: 84px;
        opacity: 1;
        color: #ffffff;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        font-family: "Source Han Sans";
        cursor: pointer;
        white-space: nowrap;
      }

      .activeBot {
        color: #70E072;
        border-bottom: 1px solid #70E072;
      }
    }

    .lang-switch {
      margin-left: 24px;
      width: 56px;
      height: 32px;
      border: 1px solid #70e072;
      background: transparent;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }

  &.home--en {
    .home-tab {
      left: 14%;

      .home-tabList {
        span {
          min-width: 132px;
          font-size: 13px;
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
